import React, { Fragment, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import browserHistory from 'react-router/lib/browserHistory';
import cn from 'classnames';

import { useAuthPersonalInfoForm } from '../utils/useAuthPersonalInfoState';
import AuthPersonalInfoForm from './AuthPersonalInfoForm';
import { isDesktop } from '../../../utils/mobileHelpers';
import ROUTES from '../../../constants/routes';
import Loader from '../../common/Loader';
import Button from '../../Button';
import styles from '../index.styles';
import { enhance } from './enhance';

const AuthPersonalInfo = ({
  dataValidationErrors: errors,
  formatMessage,
  nameSuffixList,
  profile,
  confirm,
  personalInfoChange,
  personalInfoData,
  profileEditable,
  firstStepData,
  userId,
  title,
  countries,
  pendingProcess,
  genderList,
  races,
  ethnicitys,
  changePasswordData,
  countryForOrganization,
}) => {
  const formStateRef = useRef({});

  const {
    handleFormChange,
    validateErrors,
    clearErrors,
    formState,
    isValid,
  } = useAuthPersonalInfoForm({ ...profile, ...personalInfoData }, errors, {
    showPrivacy: true,
  });

  useEffect(() => {
    if (!firstStepData) browserHistory.push(ROUTES.LOGIN);
    return () => personalInfoChange(formStateRef.current);
  }, []);

  useEffect(() => {
    formStateRef.current = formState;
  }, [formState]);

  const handleSubmit = e => {
    e.preventDefault();
    clearErrors();
    confirm({ ...formState, ...changePasswordData, id: userId });
  };
  return (
    <Fragment>
      <If condition={profile && firstStepData}>
        <div className={cn(styles.formWrapper, { mt5: !isDesktop() })}>
          <p className={styles.formTitle}>
            <span>{formatMessage({ id: title })}</span>
            <span className={styles.formStep}> (2/2)</span>
          </p>

          <div>
            <p className={styles.formText}>
              {formatMessage({ id: 'auth.signup.personalInfoDesc' })}
            </p>

            <AuthPersonalInfoForm
              showPrivacy
              {...formState}
              races={races}
              countries={countries}
              ethnicitys={ethnicitys}
              genderList={genderList}
              onChange={handleFormChange}
              formatMessage={formatMessage}
              nameSuffixList={nameSuffixList}
              validateErrors={validateErrors}
              profileEditable={profileEditable}
              countryForOrganization={countryForOrganization}
            />

            <Button
              className={cn(styles.acceptBtn, 'db mb3 w-100 lh-copy')}
              color="primary"
              raised
              type="button"
              onClick={handleSubmit}
              disabled={!isValid || pendingProcess}
            >
              {formatMessage({ id: 'common.complete' })}
            </Button>
          </div>
        </div>
        <Else />
        <Loader />
      </If>
    </Fragment>
  );
};

AuthPersonalInfo.propTypes = {
  dataValidationErrors: PropTypes.object,
  formatMessage: PropTypes.func,
  nameSuffixList: PropTypes.array.isRequired,
  profile: PropTypes.object,
  personalInfoChange: PropTypes.func.isRequired,
  profileEditable: PropTypes.bool,
  personalInfoData: PropTypes.object,
  firstStepData: PropTypes.object,
  isPasswordUpdate: PropTypes.bool,
  userId: PropTypes.number,
  confirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  countries: PropTypes.array.isRequired,
  countryForOrganization: PropTypes.string,
  pendingProcess: PropTypes.bool,
  genderList: PropTypes.array,
  races: PropTypes.array,
  ethnicitys: PropTypes.array,
};

export default enhance(AuthPersonalInfo);



// WEBPACK FOOTER //
// ./src/components/Auth/AuthPersonalInfo/index.jsx